module.exports = __webpack_public_path__ + "static/media/104.b420a5c7.png";